import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { get } from 'lodash'
import config from '../../../config'
import styles from './download-link.styl'

const decorator = ComposedComponent => {
  @connect(({ auth }) => ({
    authCode: get(auth, 'user.blobAccessAuthorizationCode'),
    token: get(auth, 'user.access_token')
  }))
  class DownloadLink extends Component {
    static propTypes = {
      authCode: PropTypes.string,
      children: PropTypes.any,
      className: PropTypes.string,
      download: PropTypes.bool,
      token: PropTypes.string,
      url: PropTypes.string,
      apiParams: PropTypes.bool,
      wrapperClassName: PropTypes.string
    }

    static defaultProps = {
      download: true,
      component: 'span'
    }

    state = {
      url: '#',
      isLoading: false
    }

    handleClick = e => {
      e.stopPropagation()

      if (this.isLoading || (this.state.url && this.state.url !== '#')) {
        return
      }

      const { authCode, url, token, apiParams } = this.props
      let fetchUrl = config.apiURL + url

      if (apiParams) {
        const params = `userType=participant`
        fetchUrl = fetchUrl.includes('?')
          ? fetchUrl + '&' + params
          : fetchUrl + '?' + params
      }

      this.setState({ isLoading: true })

      return fetch(fetchUrl, {
        headers: {
          Authorization: 'Bearer ' + token
        }
      })
        .then(res => (res.ok ? res.json() : { url: '' }))
        .then(res => {
          this.setState({ isLoading: false })

          const prefix = res.url.includes('?') ? '&' : '?'

          this.setState(
            { url: res.url + `${prefix}authorizationCode=${authCode}` },
            () => this.link.click()
          )
        })
    }

    render() {
      const { download, children, wrapperClassName, className } = this.props

      const linkClass = [className, styles.unclickable]
      const spanClass = [styles.wrapper, wrapperClassName]

      if (!this.isLoading && this.state.url && this.state.url !== '#') {
        linkClass.length = 1
      }

      return (
        <ComposedComponent
          {...this.props}
          onClick={this.handleClick}
          isLoading={this.state.isLoading}
          className={spanClass.join(' ')}
        >
          <a
            className={linkClass.join(' ')}
            ref={c => (this.link = c)}
            href={this.state.url}
            download={download}
            style={{ textDecoration: 'none' }}
          >
            {children}
          </a>
        </ComposedComponent>
      )
    }
  }
  return DownloadLink
}

export default decorator
